import { Button, Form, Input } from 'antd';
import logo from 'assets/images/logo.png';
import { message } from 'antd/lib';
import { API, PATH } from 'data/index';
import Image from 'next/image';
import { useState } from 'react';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';
import { RestAPI, ToEnglish, useAsyncClick } from 'scripts/index';
import { __PhoneFieldType, __PhoneType } from '../login.type';
import styles from './phoneForm.module.scss';

function PhoneFormComp({ setPhone }: { setPhone: (e: __PhoneType) => void }) {
    const [isValidPhone, setIsValidPhone] = useState(false);
    const [form] = Form.useForm<__PhoneFieldType>();
    const [messageApi, contextHolder] = message.useMessage();
    const finishHandler = async (values: __PhoneFieldType) => {
        return new Promise((resolve) => {
            const phone = ToEnglish(values.phone);

            RestAPI.post(API.register.register, { phone })
                .then(() => {
                    setPhone(phone);
                    resolve(true);
                })
                .catch(() => {
                    messageApi.error('عملیات با خطا مواجه شد. لطفا بعدا تلاش کنید.');
                    resolve(true);
                });
        });
    };
    const submitPhoneHandler = useAsyncClick(finishHandler);

    const validHandler = (phone: __PhoneFieldType['phone']) => {
        const regex = /(^09[0-9]{9}$)|(^\u06F0\u06F9[\u06F0-\u06F9]{9})$/;
        if (!regex.test(phone)) {
            setIsValidPhone(false);
        } else {
            setIsValidPhone(true);
        }
    };
    return (
        <div className={`${styles['login-content']} flex-column center-content-y flex-1`}>
            {contextHolder}
            <h1 className="text-center t-600 t-l-black1 mb-3 d-pre-md-none">
                تیک <span className="t-primary">سبز</span>
            </h1>
            <div className={`${styles['logo-image']} d-md-none w-100 center-content mb-4`}>
                <Image src={logo} alt="تیک سبز" width={154} height={154} />
            </div>
            <h3 className="t-h3-i t-l-black1 t-400 text-center mb-4">
                لطفا برای دریافت کد تایید، شماره تلفن همراه خود را وارد کنید
            </h3>
            <Form
                className="w-100"
                form={form}
                layout="vertical"
                requiredMark={false}
                onFinish={submitPhoneHandler.onClick}
            >
                <Form.Item<__PhoneFieldType>
                    className="mb-2-i"
                    name="phone"
                    rules={[
                        { required: true, message: 'لطفا شماره تلفن خود را وارد کنید' },
                        {
                            pattern: /(^09[0-9]{9}$)|(^\u06F0\u06F9[\u06F0-\u06F9]{9})$/,
                            message: 'لطفا شماره تلفن معتبر وارد کنید.',
                            validateTrigger: 'click',
                        },
                    ]}
                    label={<p className="t-p1 t-400 t-primary-i">شماره تلفن</p>}
                >
                    <Input
                        maxLength={11}
                        placeholder="09012345678"
                        type="tel"
                        suffix={isValidPhone ? <IoIosCheckmarkCircleOutline size={16} /> : <span></span>}
                        onChange={(e) => {
                            validHandler(e.target.value.toString());
                        }}
                    />
                </Form.Item>
                <p className="t-p3 mb-4">
                    ورود شما به معنای پذیرش{' '}
                    <a target="_blank" href={PATH.terms} className="t-p3 t-primary-i">
                        شرایط تیک سبز و قوانین حریم‌ خصوصی
                    </a>{' '}
                    است
                </p>
                <div className={`${styles['btns']} center-content flex-column w-100`}>
                    <Button loading={submitPhoneHandler.loading} htmlType="submit" className="w-100">
                        ارسال کد تایید
                    </Button>
                </div>
            </Form>
        </div>
    );
}

export default PhoneFormComp;
